import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { DatavizBlockContentBlock } from "~/types/asgard/PostContentBlock";
import { EvervizChartProps } from "./EvervizChart";

export const apiToEvervizChartProps = (
  apiData: DatavizBlockContentBlock
): EvervizChartProps => ({
  headline: heDecodeOrDefault(apiData.dataviz_block_inner.headline),
  subtitle: heDecodeOrDefault(apiData.dataviz_block_inner.subtitle),
  title: heDecodeOrDefault(apiData.dataviz_block_inner.title),
  footnote: heDecodeOrDefault(apiData.dataviz_block_inner.footnote),
  logo: heDecodeOrDefault(apiData.dataviz_block_inner.logo),
  image: heDecodeOrDefault(apiData.dataviz_block_inner.image),
  altText: heDecodeOrDefault(apiData.dataviz_block_inner.image_alt),
  injectId: heDecodeOrDefault(apiData.dataviz_block_inner.injectId),
  chartId: heDecodeOrDefault(apiData.dataviz_block_inner.chartId),
  methodology: heDecodeOrDefault(apiData.dataviz_block_inner.methodology),
  evervizEmbedCode: heDecodeOrDefault(apiData.dataviz_block_inner.headline),
  contentRef: heDecodeOrDefault(apiData.dataviz_block_inner.headline),
});
